import { BrowserRouter as Router, Route } from "react-router-dom";
import Form from "./form";
import Menu from "./menu";
import Preview from "./preview";
import SocialProof from "./social-proof";
import Recommender from "./recommender";
import WheelFortune from "./wheel-fortune";
import ProductReviews from "./product-reviews";
import { useEffect } from "react";

//import DeviceDetector from "device-detector-js";

// if (!sessionStorage.getItem("device")) {
//   const deviceDetector = new DeviceDetector();
//   const device = deviceDetector.parse(navigator.userAgent);

//   sessionStorage.setItem("device", JSON.stringify(device));
// }

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

const App = () => {
  useEffect(() => {
    if (!inIframe()) {
      document.body.style.overflow = "auto";
    }
  }, []);
  return (
    <Router>
      <Route exact path="/menu" component={Menu}></Route>
      <Route exact path="/menu/:id" component={Menu}></Route>

      <Route exact path="/form/:id" component={Form}></Route>

      <Route exact path="/popup/:id" component={Form}></Route>

      <Route exact path="/recommender/:p" component={Recommender}></Route>

      <Route exact path="/social-proof/:p" component={SocialProof}></Route>

      <Route exact path="/wheel-fortune/:id" component={WheelFortune}></Route>
      <Route
        exact
        path="/wheel-fortune/:id/:wid"
        component={WheelFortune}
      ></Route>

      <Route exact path="/product-reviews" component={ProductReviews}></Route>
      <Route
        exact
        path="/product-reviews/:id/:wid"
        component={ProductReviews}
      ></Route>

      <Route exact path="/preview/:view" component={Preview}></Route>
      <Route exact path="/preview/:view/:p" component={Preview}></Route>
    </Router>
  );
}

export default App;
